import React from 'react';
import type { TextProps } from '@usewaypoint/block-text';
import { useCurrentBlockId } from '../../editor/EditorBlock';
import { useSelectedBlockId, setDocument, useDocument } from '../../editor/EditorContext';
import TextWithPlaceholders from './TextWithPlaceholders';
import InlineTextEditor from './InlineTextEditor';

/**
 * Smart Text component that switches between read-only and editable modes
 * - When selected: Renders TipTap editor for inline editing
 * - When not selected: Renders read-only TextWithPlaceholders
 */
export default function EditableText(props: TextProps) {
  const blockId = useCurrentBlockId();
  const selectedBlockId = useSelectedBlockId();
  const document = useDocument();
  const isSelected = selectedBlockId === blockId;

  const handleSave = (markdown: string) => {
    // Update the block's text content in Zustand when user blurs
    const currentBlock = document[blockId];
    if (currentBlock && currentBlock.type === 'Text') {
      setDocument({
        [blockId]: {
          ...currentBlock,
          data: {
            ...currentBlock.data,
            props: {
              ...currentBlock.data.props,
              text: markdown,
              markdown: true,
            },
          },
        },
      });
    }
  };

  // When selected, render editable TipTap editor
  if (isSelected) {
    return (
      <InlineTextEditor
        initialContent={props.props?.text || ''}
        onSave={handleSave}
        blockId={blockId}
        style={props.style}
      />
    );
  }

  // When not selected, render read-only preview
  return <TextWithPlaceholders {...props} />;
}
